export enum RequestImpactEnum {
  High = 1,
  Medium = 2,
  Low = 3,
}
